import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useAddCustomerMutation } from "../../store/services/customerService";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import colors from "../../styles/colors";
import { useSendNotificationMutation } from "../../store/services/notificationService";

const labelStyle = {
  fontFamily: "PSBo",
  fontSize: 15,
  color: "#333",
  mb: 0.5,
};

const NotificationModel = ({ open, onClose, users }) => {
  const words = useSelector((state) => state.authReducer.words);

  const [formValues, setFormValues] = useState({

  });

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [sendNotification, { isLoading }] = useSendNotificationMutation();




  const handleSubmit = async () => {

    if (!title) return toast.error("Please enter title");
    if (!description) return toast.error("Please enter description");


    const selectedUsers = users.map((v, i) => {
      return v.id;
    });

    if (!selectedUsers.length) return toast.error("Please select user");

    const body = {
      title,
      description,
      user_id: selectedUsers,
    };


    try {
      const response = await sendNotification(body).unwrap();
      if (response.status === "1") {
        toast.success("Notification send successfully!");
        onClose(); // Close the dialog on success
      } else {
        toast.error("Failed to add send notification. Please try again later.");
      }
    } catch (error) {
      console.error("Error adding customer:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <>



      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <Loader open={isLoading} />

        <DialogTitle sx={{ fontFamily: "PSBo", fontSize: 18, color: "#333" }}>
          {words["Send Notification"]}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Typography sx={labelStyle}>{words["Title"]}*</Typography>
              <TextField
                fullWidth
                name="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography sx={labelStyle}>{words["Description"]}*</Typography>
              <TextField
                fullWidth
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: "20px",
              fontSize: 12,
              padding: "8px 16px",
              textTransform: "none",
              fontFamily: 'PMe'
            }}
          >
            {words["Cancel"]}
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={isLoading}
            sx={{
              backgroundColor: colors.primary,
              fontSize: 12,
              color: "white",
              borderRadius: "20px",
              padding: "8px 26px",
              textTransform: "none",
              fontFamily: 'PMe'
            }}
          >
            {isLoading ? "Submitting..." : words["Send"]}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NotificationModel;

